export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9647.079699b5.jpg";